import { observer } from 'mobx-react-lite'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import Styles from '../../BlogMetadata.module.scss'
import { BlogMetadataCompositionReturn } from '../../hooks/useBlogMetadataComposition'
import { BlogMetadataHeader, BlogMetadataFormFields, BlogMetadataImageSection, BlogMetadataCategoriesSection } from '..'
import { WordPressAuthorSelect } from '../integrations'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const WordPressBlogMetadataLayout = observer(
  ({ integrationInfo, states, handlers, refs }: BlogMetadataCompositionReturn) => {
    const isSystemRedesignEnabled = useIsSystemRedesign()
    const hasWordPressAuthors = states.integrationState.availableAuthors.length > 0

    return (
      <div className={Styles.container} data-testid="blog-metadata-v2">
        <VisuallyHidden>
          <input
            aria-label="Upload featured image"
            ref={refs.fileInputRef}
            type="file"
            multiple={false}
            onChange={handlers.imageHandlers.handleFileInputChange}
            accept="image/*"
          />
        </VisuallyHidden>

        <BlogMetadataHeader blogIntegrationsCount={integrationInfo.blogIntegrationsCount} />

        <BlogMetadataFormFields
          formState={states.formState}
          handlers={handlers.enhancedFormHandlers}
          shouldShowAuthorField={!hasWordPressAuthors}
        />

        {hasWordPressAuthors && (
          <div className={Styles.categoryDropdownContainer}>
            {states.integrationState.availableAuthors?.length > 1 && <label className={Styles.textFieldLabel}>Author</label>}
            <div className={Styles.categoryDropdown}>
              <WordPressAuthorSelect
                authors={states.integrationState.availableAuthors.map((author) => ({
                  id: Number(author.id),
                  name: author.name,
                  slug: '',
                }))}
                selectedAuthorId={states.integrationState.selectedAuthorId}
                onAuthorSelect={handlers.enhancedIntegrationHandlers.handleAuthorSelect}
                disabled={integrationInfo.isPostPublished}
                size={isSystemRedesignEnabled ? 'md' : 'lg'}
              />
            </div>
          </div>
        )}

        <BlogMetadataImageSection imagesState={states.imageState} handlers={handlers.imageHandlers} />

        <BlogMetadataCategoriesSection
          categoriesState={states.categoriesState}
          categoriesHandlers={handlers.enhancedCategoriesHandlers}
          tagsState={states.tagsState}
          tagsHandlers={handlers.enhancedTagsHandlers}
          useCategoryDropdown={states.integrationState.useCategoryDropdown}
          availableCategories={states.integrationState.availableCategories}
          allowAddingCategories={states.integrationState.allowAddingCategories}
        />
      </div>
    )
  },
)
